import { createFileRoute } from "@tanstack/react-router";
import { TrustCentre } from "@/components/TrustCentre";
import { Header, Footer, FloatingWhatsApp } from "@/components/SitePage";
import { buildHead, breadcrumbLD } from "@/content/seo";

const TITLE = "Trust Centre — Vilamoura Dreams Cruises";
const DESC =
  "Licences, insurance, data privacy and payment security behind Morningstar Yacht. Full transparency for guests booking a private charter from Marina de Vilamoura.";
const PATH = "/trust-centre";

export const Route = createFileRoute("/trust-centre")({
  component: TrustCentrePage,
  head: () =>
    buildHead({
      lang: "en",
      path: PATH,
      title: TITLE,
      description: DESC,
      keywords:
        "vilamoura dreams cruises trust centre, morningstar yacht licence, rnaat 743/2022, luxury reference lda, dgrm skipper, amn survey, stripe payments, gdpr yacht charter",
      altPath: { en: PATH, pt: "/pt/centro-de-confianca" },
      extraScripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(
            breadcrumbLD([
              { name: "Home", path: "/" },
              { name: "Trust Centre", path: PATH },
            ]),
          ),
        },
      ],
    }),
});

function TrustCentrePage() {
  return (
    <div className="min-h-screen bg-background">
      <Header lang="en" />
      <main className="pt-20 lg:pt-28">
        <header id="top" className="border-b border-border/40 bg-background">
          <div className="mx-auto max-w-4xl px-6 py-10 md:py-14">
            <p className="text-[11px] uppercase tracking-[0.22em] text-gold-deep font-semibold">
              Vilamoura Dreams Cruises
            </p>
            <h1 className="mt-2 font-serif text-3xl leading-tight text-foreground md:text-5xl">
              Trust Centre
            </h1>
            <p className="mt-4 max-w-2xl text-sm leading-relaxed text-muted-foreground">
              Every guarantee behind a charter aboard Morningstar — licences, insurance,
              crew credentials, data privacy and payment security, verifiable with the
              Portuguese and European authorities that regulate our operation.
            </p>
          </div>
        </header>
        <section className="mx-auto max-w-4xl px-6 py-12 md:py-16">
          <TrustCentre lang="en" />
        </section>
      </main>
      <Footer lang="en" />
      <FloatingWhatsApp lang="en" />
    </div>
  );
}